module.exports = __webpack_public_path__ + "img/kv-pc_x2.4f45081.jpg";